import { getForm } from 'remote-com-shared/domains/hubspot/services';
import { isDefaultLocaleLanguage } from 'remote-com-shared/domains/locales/helpers';

import { querySharedServices } from '@/src/domains/shared/services';
import { queryGDPRErasurePage } from '@/src/views/GDPRErasureRequest/services';

export { GDPRRequestErasureView as default } from '@/src/views/GDPRErasureRequest';

export async function getStaticProps({ preview = false, previewData = {}, locale, defaultLocale }) {
  if (!isDefaultLocaleLanguage(locale, defaultLocale)) {
    return { notFound: true };
  }

  const pageData = await queryGDPRErasurePage({ previewData });
  const { data: hubspotFormDefinition } = await getForm(pageData.gated_form_id);

  const sharedServices = await querySharedServices({ previewData, locale });

  return {
    props: { preview, pageData, hubspotFormDefinition, sharedServices },
  };
}
